export default function LoadingSpinner({ size = 'md', className = '' }) {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
  };

  return (
    <div 
      className={`${sizes[size]} border-[#1E2D45] border-t-[#0070F3] rounded-full animate-spin ${className}`}
      data-testid="loading-spinner"
    />
  );
}
